export default __webpack_public_path__ + "static/media/SconeProductInfo.644c326a.png";